import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=5861d163&scoped=true&lang=pug&"
import script from "./BaseDrawer.vue?vue&type=script&lang=js&"
export * from "./BaseDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=5861d163&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861d163",
  null
  
)

export default component.exports